var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Whoops 404!! The page is not available. "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.back($event)}}},[_vm._v("Go back")])])}
var staticRenderFns = []

export { render, staticRenderFns }